export const REDIRECT_TO = 'redirectTo'